import React from "react";
import { Link } from "react-router-dom";
import Logo from "./Logo";
import { LangToggle, useLang } from "../lib/i18n";
import { getCart } from "../lib/cart";
import { useEffect, useState } from "react";

export default function TopNav({ minimal = false, logoOnly = false }) {
  const { lang } = useLang();
  const [count, setCount] = useState(getCart().reduce((s,i)=>s+i.qty,0));
  useEffect(() => {
    const fn = () => setCount(getCart().reduce((s,i)=>s+i.qty,0));
    window.addEventListener("cart-updated", fn);
    return () => window.removeEventListener("cart-updated", fn);
  }, []);

  const navText = {
    home: lang === "es" ? "Inicio" : "Home",
    shop: lang === "es" ? "Tienda" : "Shop",
  };

  if (logoOnly) {
    return (
      <header className="hp-nav" data-testid="top-nav-minimal">
        <Logo size="md" linkTo="/" testId="nav-logo"/>
      </header>
    );
  }

  return (
    <header className="hp-nav" data-testid="top-nav">
      <Logo size="md" linkTo="/" testId="nav-logo"/>
      {!minimal && (
        <ul className="hp-nav-links">
          <li><Link to="/" data-testid="nav-home-link">{navText.home}</Link></li>
          <li><Link to="/estore" data-testid="nav-shop-link">{navText.shop}</Link></li>
        </ul>
      )}
      <div className="hp-nav-right">
        {!minimal && <LangToggle />}
        <Link to="/cart" className="hp-cart" aria-label="Cart" data-testid="nav-cart" style={{fontSize:"1.2rem"}}>
          🛒{count>0 && <span className="hp-cart-badge">{count}</span>}
        </Link>
      </div>
    </header>
  );
}
